import request from 'sb-request'


const fetch = (params) =>
  request.get('rest/engine/smartsearch/brands', params)


export default {
  fetch,
}
